module.exports = __webpack_public_path__ + "img/23.7c61761d.jpg";